export function setMenu (state, data) {
  let current = state[data]
  state.currentMenu = current
}
